"use strict";import{css as t}from"@spectrum-web-components/base";const e=t`
:host{--spectrum-illustratedmessage-description-max-width:500px;--spectrum-illustratedmessage-heading-max-width:500px;--spectrum-illustratedmessage-illustration-margin-bottom:24px;--spectrum-illustratedmessage-heading-margin:0;--spectrum-illustratedmessage-description-margin:4px 0 0 0}:host{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:center;text-align:center}#illustration{margin-bottom:var(
--spectrum-illustratedmessage-illustration-margin-bottom
)}#heading{color:var(
--spectrum-illustratedmessage-heading-color,var(--spectrum-global-color-gray-800)
);font-size:var(
--spectrum-illustratedmessage-heading-font-size,var(--spectrum-alias-heading-m-text-size)
);font-weight:var(
--spectrum-illustratedmessage-heading-font-weight,var(--spectrum-alias-heading-text-font-weight-regular)
);margin:var(--spectrum-illustratedmessage-heading-margin);max-width:var(--spectrum-illustratedmessage-heading-max-width)}#description{color:var(
--spectrum-illustratedmessage-description-color,var(--spectrum-global-color-gray-700)
);font-style:var(
--spectrum-illustratedmessage-description-font-style,var(--spectrum-global-font-style-regular)
);margin:var(--spectrum-illustratedmessage-description-margin);max-width:var(--spectrum-illustratedmessage-description-max-width)}:host([cta]) #description{font-style:var(
--spectrum-illustratedmessage-description-font-style,var(--spectrum-global-font-style-regular)
)}#illustration{fill:currentColor;stroke:currentColor;color:var(
--spectrum-global-color-gray-500
)}::slotted(svg[viewBox]){width:100%}
`;export default e;
//# sourceMappingURL=illustrated-message.css.js.map
